"use strict";

class EntityList {
    constructor(listId) {
        this.entityList = $(`#${listId}`);
        this.recordActiveSwitch = this.entityList.find(
            'input[name="record_active"]'
        );
        this.recordFavoriteSwitch = this.entityList.find(
            'input[name="record_favorite"]'
        );
        this.recordLockedSwitch = this.entityList.find(
            'input[name="record_locked"]'
        );
        this.recordWarningSwitch = this.entityList.find(
            'input[name="has_warning"]'
        );
        this.deleteRecordForm = this.entityList.find(".deleteRecord");
    }

    toggleActive(event) {
        const switchInput = $(event.target);
        const form = switchInput.parent();

        $.ajax({
            headers: {
                "X-CSRF-Token": form.find('input[name="_token"]').val(),
            },
            url: form.attr("action") ?? form.attr("data-action"),
            type: "PATCH",
            data: { is_active: switchInput.data("isactive") }
        })
            .done(() => {
                switchInput.trigger("blur");
                switchInput.data("isactive", switchInput.data("isactive") === 1 ? 0 : 1);
            });
    }

    toggleWarning(event) {
        const switchInput = $(event.target);
        const form = switchInput.parent();

        $.ajax({
            headers: {
                "X-CSRF-Token": form.find('input[name="_token"]').val(),
            },
            url: form.attr("action") ?? form.attr("data-action"),
            type: "PATCH",
            data: { has_warning: switchInput.data("haswarning") }
        })
            .done(() => {
                switchInput.trigger("blur");
                switchInput.data("haswarning", switchInput.data("haswarning") === 1 ? 0 : 1);
            });
    }
    toggleLocked(event) {
        const switchInput = $(event.target);
        const form = switchInput.parent();

        $.ajax({
            headers: {
                "X-CSRF-Token": form.find('input[name="_token"]').val(),
            },
            url: form.attr("action") ?? form.attr("data-action"),
            type: "PATCH",
            data: { is_locked: switchInput.data("islocked") }
        })
            .done(() => {
                switchInput.trigger("blur");
                switchInput.data("islocked", switchInput.data("islocked") === 1 ? 0 : 1);
            });
    }

    toggleFavorite(event) {
        const switchInput = $(event.target);
        const form = switchInput.parent();

        $.ajax({
            headers: {
                "X-CSRF-Token": form.find('input[name="_token"]').val(),
            },
            url: form.attr("action"),
            type: "PATCH",
            data: { is_favorite: switchInput.data("isfavorite") }
        })
            .done(() => {
                switchInput.trigger("blur");
                switchInput.data("isfavorite", switchInput.data("isfavorite") === 1 ? 0 : 1);
            });
    }

    deleteRecord(e) {
        e.preventDefault();
        if (confirm("Are you sure you want to delete this record?")) {
            return e.target.submit();
        }

        return false;
    }
}

export default EntityList;
